import React, { useEffect } from 'react';
import {
    Box,
    TextField,
    Button,
    Typography,

} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import {
    createState,
    Downgraded,
    useState,
} from '@hookstate/core';
import * as forge from 'node-forge';
//import CircularProgress from '@mui/material/CircularProgress';
import Logo from '../../assets/images/logo.png';
import { withRouter } from 'react-router-dom';
import validator from 'validator';
import { useHistory } from 'react-router-dom';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
//import Helper from '../../utility/helper';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';

const userState = createState({
    email: '',
});

const helperRoot = {
    margin: 0,
};

const ForgotPassword = (props) => {
    const loading = useState(false);
    const state = useState(userState);
    const history = useHistory()
    const [emailErr, setEmailErr] = React.useState('');
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    useEffect(() => {
        props.setLogin(false);
    }, [])
    const validateEmail = (value) => {
        value = value.trim();
        if (validator.isEmail(value)) {
            return true;
        } else return false;
    };
    const isEmail = () => {
        const email = state.email.get().trim();
        const flag = email === '' ? false : email != '' ? validateEmail(email) : true;
        const emlErr = flag ? '' : 'Please enter valid Email';
        setEmailErr(emlErr);
    };

    const handleCancel = () => {
        history.push({ pathname: '/' })
        props.setLogin(true);
    };
    const handleSubmit = () => {
        //event.preventDefault();
        if (state.email.get().trim() !== '' && emailErr.length === 0) {
            loading.set(true);
            // if (loginType == 'janrain') {
            let req = { ...state.attach(Downgraded).get() };
            // eslint-disable-next-line no-undef
            const publicKey = process.env.REACT_APP_PUBLIC_KEY;

            var rsa = forge.pki.publicKeyFromPem(publicKey);
            let encryptedEmail = window.btoa(rsa.encrypt(req.email.toLowerCase()));
            req = {
                email: encryptedEmail,
            };

            ApiHelper.post(APIURLConstants.FORGOT_PASSWORD, req)
                .then((res) => {
                    if (res.data.status === 200) {
                        // Helper.setStorage('chk', 'jr');

                        const response = (res.data);
                        console.log(response)
                        if (response.ok) {

                            snackBarProps.openSnack = true;
                            setSnackBarProps({
                                ...snackBarProps,
                                openSnack: true,
                                variant: 'success',
                                message: 'Reset link sent on registered email',
                            });
                            state.email.set('')
                        } else {
                            snackBarProps.openSnack = true;
                            setSnackBarProps({
                                ...snackBarProps,
                                openSnack: true,
                                variant: 'error',
                                message: response.message,
                            });
                        }
                    } else if (res.data.status === 404) {
                        snackBarProps.openSnack = true;
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: res.data.message,
                        });
                    }
                    loading.set(false);
                })
                .catch((error) => {
                    let message = '';
                    if (error.response && error.response.status === 401) {
                        message = 'Access denied';
                    } else {
                        message = 'Your email or password was invalid';
                    }
                    snackBarProps.openSnack = true;
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                    loading.set(false);
                });
        } else {
            isEmail()
        }
    }
    return (
        <Box sx={{ width: '100%', height: '100vh' }}>


            <Box
                sx={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                }}>
                <Box className="forgotBox">
                    <Box className="loginHeader">
                        <Box
                            component="img"
                            alt="logo."
                            src={Logo}
                            sx={{ height: 42 }}
                        />
                    </Box>
                    <Box className="loginContentBox">
                        <Box sx={{ pt: 2 }}>
                            <Typography variant='body2' color='CaptionText'>We will send recovery link to</Typography>
                        </Box>
                        <Box
                            component="form"
                            autoComplete="off"
                        // onSubmit={handleSubmit}
                        >
                            <Box className="textContent" sx={{ pt: 1 }}>
                                <TextField
                                    required
                                    size="small"
                                    label="Email"
                                    autoComplete="off"
                                    value={state.email.get()}
                                    onChange={(event) => {
                                        setEmailErr('')
                                        let str = event.target.value;
                                        str = str.replace(/^\s+/g, '');
                                        state.email.set(str);
                                    }}
                                    onBlur={() => isEmail()}
                                    helperText={emailErr}
                                    error={
                                        emailErr.length > 0
                                            ? true
                                            : false
                                    }
                                    inputProps={{ maxLength: 100 }}
                                    sx={{ width: '100%' }}
                                    FormHelperTextProps={{
                                        classes: {
                                            root: helperRoot,
                                        },
                                    }}

                                />
                            </Box>
                            <Box className="textContent" sx={{ pt: 4 }}>
                                <LoadingButton
                                    loading={loading.get()}
                                    color='primary'
                                    variant="contained"
                                    loadingPosition='end'
                                    onClick={handleSubmit}
                                    sx={{ width: '100%' }}

                                >
                                    Send
                                </LoadingButton>
                                {/* <Button
                                        //type="submit"
                                        onClick={handleSubmit}
                                        variant="contained"
                                        color="secondary"
                                        sx={{ width: '100%' }}>
                                        Send Mail
                                    </Button> */}
                            </Box>
                            <Box className="textContent" >
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    sx={{ width: '100%' }}
                                    onClick={handleCancel}>
                                    Cancel
                                </Button>
                            </Box>

                        </Box>
                    </Box>
                </Box>
            </Box>



            {
                snackBarProps.openSnack && (
                    <CustomizedSnackbars
                        {...snackBarProps}
                        onClose={() =>
                            setSnackBarProps({
                                ...snackBarProps,
                                openSnack: false,
                            })
                        }></CustomizedSnackbars>
                )
            }
        </Box >
    )
}

export default withRouter(ForgotPassword)
